import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import * as translationService from '../services/translationService'
import * as routeService from '../services/routeService'
import { TextContainer, Button, PropertyBar, Markdown, DisplayText } from '../components'

class SentView extends React.PureComponent {
  render() {
    const { property, step } = this.props

    const handleStartFlowClick = event => {
      event.preventDefault()
      routeService.goToNextFlowPage(step)
    }

    return (
      <div>
        {property && <PropertyBar property={property} />}
        <TextContainer>
          <DisplayText size="small">{this.props.user.firstname},</DisplayText>
          <Markdown source={translationService.startIntro()} />
          <Button size="large" primary onClick={handleStartFlowClick}>
            {translationService.overviewStartCandidacyFlow()}
          </Button>
        </TextContainer>
      </div>
    )
  }
}

SentView.propTypes = {
  property: PropTypes.any,
  step: PropTypes.any,
  user: PropTypes.object,
}

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { user } = AuthReducer
  const { property, step } = FlowReducer
  return {
    user,
    property,
    step,
  }
}

export default compose(
  translate('translations'),
  connect(mapStateToProps),
)(SentView)



// WEBPACK FOOTER //
// ./src/views/StartView.js